<template>
  <div class="app flex-row align-items-center" id="formLogin">
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
import {authLogin} from "@/security/index";
import BaseLoading from "../base/BaseFormLoading";
import {APP_CODE, CLIENT_ID} from '../../constant';

export default {
  name: "Login",
  components: {BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted: function () {
  },
  created: function () {
    //token
    // if (this.$route.query && this.$route.query.token && this.$route.query.exp) {
    //   localStorage.setItem(ACCESS_TOKEN_NAME, this.$route.query.token)
    //   this.getUserInfoByToken();
    // } else {
    //   window.location.href = this.ssoUrl;
    // }

    //auth_code
    if (this.$route.query && this.$route.query.code) {
      this.getUserInfoByToken(this.$route.query.code);
    } else {
      window.location.href = this.ssoUrl;
    }
  },
  data: function () {
    return {
      loading: {value: true},
      //token
      // ssoUrl: `${process.env.SSO_ADDRESS}?redirect-uri=${encodeURIComponent(process.env.URI_REDIRECT)}&app-code=${APP_CODE}`
      //oauth code
      ssoUrl: (this.$route.query && this.$route.query.isLogout == true) ? process.env.SSO_ADDRESS : `${process.env.SSO_ADDRESS}/login.html?redirect-uri=${encodeURIComponent(process.env.URI_REDIRECT)}&client-id=${CLIENT_ID}`
    };
  },
  computed: {},
  watch: {},
  methods: {
    getUserInfoByToken: function (auth_code) {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/oauth/user",
        //oauth code
        isRequestBearerToken: false,
        dataSubmit: function () {
          return {
            auth_code: auth_code
          }
        },
        successCallback: function (response) {
          if (response.status === 200) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              // that.showErrorMsg({message: that.$helper.getStringError(dataResponse.data)});
              window.location.href = process.env.SSO_ADDRESS;
            } else {
              //token
              // authLogin(dataResponse.data.accessToken, dataResponse.data.roles, dataResponse.data.username, dataResponse.data.userId, that.$route.query.exp);
              //oauth code
              authLogin(dataResponse.data.accessToken, dataResponse.data.roles, dataResponse.data.username, dataResponse.data.userId, dataResponse.data.expires, dataResponse.data.locationCode, dataResponse.data.fullName, dataResponse.data.userPosition);
            }
          } else {
            window.location.href = this.ssoUrl
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  }
};
</script>

